module.exports = __webpack_public_path__ + "img/kehujiancexuzhi.28b70aa5.jpg";